var map = {
	"./cqsoft.png": [
		848,
		848
	],
	"./logoair.jpg": [
		921,
		921
	],
	"./logoair.png": [
		169,
		169
	],
	"./logocolon.jpg": [
		180,
		180
	],
	"./logocolon.png": [
		624,
		624
	],
	"./logocqsoft.png": [
		749
	],
	"./logodiri.png": [
		923,
		923
	],
	"./logogarcia.png": [
		18,
		18
	],
	"./logogarcia.png.old": [
		78,
		78
	],
	"./logoiddpcuad.png": [
		605
	],
	"./logopiccardo.png": [
		276,
		276
	],
	"./logosayago.jpg": [
		133,
		133
	],
	"./logosayago.png": [
		901,
		901
	],
	"./logowaven.png": [
		134
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64;
module.exports = webpackAsyncContext;